import script from "./related.vue?vue&type=script&lang=ts&setup=true"
export * from "./related.vue?vue&type=script&lang=ts&setup=true"

import "./related.vue?vue&type=style&index=0&id=14ecc2ea&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ecc2ea"]])

export default __exports__